/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2026.
 *  Title: AggiornamentoMassivo.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/Modules/Klima/AggiornamentoMassivo.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 19/03/26, 10:05;
 *  Updated at: 19/03/26, 10:05;
 *  ```
 */

import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {ApiPathsService} from "../../../app/api-paths.service";
import {Permission} from "../../../app/Login/_guards/Permission";
import {
  DateAddDays,
  dateTimeStringToFormattedDate,
  dateTimeStringToFormattedDateTime,
  DateToString
} from "../../Utility/DateUtility";
import {KlimaUtility} from "./KlimaUtility";

function Headers() {
  return [
    CampoAggiuntivo.Html("Annullato", (x)=>x.annullato ? `<i class="fa-solid fa-times"></i>`: ``),
    CampoAggiuntivo.TextField("Cliente", "cliente", "col-12", {modificabile:false}),
    CampoAggiuntivo.Html("Preventivo", (x)=>`${ x.dataCreazione ? dateTimeStringToFormattedDate(x.dataCreazione): ''} <br> ${x.P}`),
    CampoAggiuntivo.Html("Attesa conferma", (x)=>`${ x.data_accettazione ? dateTimeStringToFormattedDate(x.dataAccettazione): ''}`),
    CampoAggiuntivo.Html("CO (conf. ordine)", (x)=>`${ x.dataConferma ? dateTimeStringToFormattedDate(x.dataConferma): ''} <br> ${x.CO}`),
    CampoAggiuntivo.Html("preparazione ordine", (x)=>`${x.magazzino ?? ''} <br> ${x.dataPrep ? dateTimeStringToFormattedDate(x.dataPrep): ''}<br> ${x.numeroPrep}`),
    CampoAggiuntivo.Html("DDT", (x)=>`${x.numeroDdt ?? ''} <br> ${x.dataDdt ? dateTimeStringToFormattedDate(x.dataDdt): ''}`),
    CampoAggiuntivo.Html("Consegna", (x)=>`${x.vettore ?? ''} <br> ${x.dataConsegna ? dateTimeStringToFormattedDate(x.dataConsegna): ''} <br> ${x. link ?'link tracking': ''}`, ()=>true, {onClick: (x,y)=>{
        window.open(x.link);
      }}),
    CampoAggiuntivo.Html("Fattura", (x)=>`${x.numeroFattura ?? ''} <br> ${x.dataFattura ? dateTimeStringToFormattedDate(x.dataFattura): ''}`),
    CampoAggiuntivo.Html("Cond. pagamento", (x)=>`${x.pagamento ?? ''}`),
  ]
}

function PrintHeaders() {
  return [
    CampoAggiuntivo.Html("Annullato", (x)=>x.annullato ? `Si`: `No`),
    CampoAggiuntivo.TextField("Cliente", "cliente", "col-12", {modificabile:false}),
    CampoAggiuntivo.Html("Data Preventivo", (x)=>`${ dateTimeStringToFormattedDate(x.dataCreazione)}`),
    CampoAggiuntivo.Html("Preventivo", (x)=>`${x.P}`),
    CampoAggiuntivo.Html("Attesa conferma", (x)=>`${ x.dataAccettazione ? dateTimeStringToFormattedDate(x.dataAccettazione) : ''}`),
    CampoAggiuntivo.Html("Data CO", (x)=>`${ x.dataConferma ? dateTimeStringToFormattedDate(x.dataConferma) : ''}`),
    CampoAggiuntivo.Html("CO (conf. ordine)", (x)=>`${x.CO}`),
    CampoAggiuntivo.Html("magazzino", (x)=>`${x.magazzino ?? ''}`),
    CampoAggiuntivo.Html("Data Preparazione ordine", (x)=>`${x.dataPrep ? dateTimeStringToFormattedDate(x.dataPrep) :''}`),
    CampoAggiuntivo.Html("Preparazione ordine", (x)=>`${x.numeroPrep}`),
    CampoAggiuntivo.Html('Data DDT', (x)=>x.dataDdt ? dateTimeStringToFormattedDate(x.dataDdt): ''),
    CampoAggiuntivo.Html("DDT", (x)=>`${x.numeroDdt ?? ''}`),
    CampoAggiuntivo.Html("Data consegna", (x)=>`${x.dataConsegna ? dateTimeStringToFormattedDate(x.dataConsegna): ''}`),
    CampoAggiuntivo.Html("Vettore", (x)=>`${x.vettore ?? ''}`),
    CampoAggiuntivo.Html("Link", (x)=>x.link ?? ''),
    CampoAggiuntivo.Html("Data Fattura", (x)=>x.dataFattura ? dateTimeStringToFormattedDate(x.dataFattura): ''),
    CampoAggiuntivo.Html("Fattura", (x)=>`${x.numeroFattura ?? ''} `),
    CampoAggiuntivo.Html("Cond. pagamento", (x)=>`${x.pagamento ?? ''}`),
    ];
}



function lead_time() {
  var OBJ: OggettoConfig = {
    Id: "lead_time",
    RestRoute: "/progetti/progetti",
    ListResponseHasData:true,
    ListDefaultFilter:{page:1, size:20, periodo: true, inizio: DateToString(DateAddDays(new Date(), -30)), fine: DateToString(new Date())},
    listRoute:'documenti',
    FullExportExcel:true,
    Headers: Headers(),
    PrintHeaders: PrintHeaders(),
    badges:[
      {field: "total", nome:"Ordini", color:""}
    ],
    ListMap: (data:any[])=>{
      return data;
    },
    Filters:[
      CampoAggiuntivo.SingleDropdown(
        "Tipologia Ordine",
        "tipo",
        [
          {id:{service:true, nazioni: undefined}, label:'Ricambi'},
          {id:{service:false, nazioni: ['ITA', '']}, label:'Italia'},
          {id:{service:false, nazioni: KlimaUtility.countryCodes.filter(c=>c !== 'ITA')}, label:'Estero'}
        ],
        'label',
        {OnChangeFunc:(filter, a,b,c)=>{
          var newFilter = a?.id ?? {service:null, nazioni: undefined};
          Object.getOwnPropertyNames(newFilter).forEach(name=>{
            filter[name] = newFilter[name];
          })
        }},'col-lg-2' ),
      CampoAggiuntivo.InputField("Inizio", "inizio", "date", 'col-lg-2'),
      CampoAggiuntivo.InputField("Fine", "fine", "date", 'col-lg-2'),
      CampoAggiuntivo.SingleDropdown("Corriere", "vettore", '/anagrafica/clienti/vettori', 'vettore', {},'col-lg-2'),
      CampoAggiuntivo.TextField("Cerca Cliente", "cliente"),
      CampoAggiuntivo.TextField("Cerca Num. Ordine", "codice", 'col-lg-2'),
      CampoAggiuntivo.Html("", ()=>`Date: `, ()=>true, {class:"col-1", prevDivClass:'col-lg-12'}),
      CampoAggiuntivo.SingleDropdown("CO (conf. ordine)", "noConferma", [{id:true, label:'Assente'}, {id:false, label:'Presente'}], 'label', {},'col-lg-2'),
      CampoAggiuntivo.SingleDropdown("Preparazione Ordine", "noPrep", [{id:true, label:'Assente'}, {id:false, label:'Presente'}], 'label', {},'col-lg-2'),
      CampoAggiuntivo.SingleDropdown("DDT", "noDdt", [{id:true, label:'Assente'}, {id:false, label:'Presente'}], 'label', {},'col-lg-2'),
      CampoAggiuntivo.SingleDropdown("Data di consegna", "noConsegna", [{id:true, label:'Assente'}, {id:false, label:'Presente'}], 'label', {},'col-lg-2'),
      CampoAggiuntivo.SingleDropdown("Fattura", "noFattura", [{id:true, label:'Assente'}, {id:false, label:'Presente'}], 'label', {},'col-lg-2'),
    ],
    MenuItems:[
      {
        path: "/shared/dynamiclist/lead_time",
        title: "Lead Time",
        icon: "fa-solid fa-stopwatch",
        class: "",
        capacita: ["leadtime-menu"],
        ruoliOperativi:["SA", "AZ"]
      },
    ],
    AzioniLista:[
      {
        nome: 'View',
        close: false,
        icon: 'fa-solid fa-eye text-info ',
        class: ' btn ',
        labelClass: 'text-info ',
        noGet:true,
        single:true,
        type: 'func',
        tooltip: "Apri",
        //hideif: {func: (x,perm: Permission)=>perm.isOperativeRoles(['SA'])},
        func: (a, api:ApiPathsService, end, toastService) => {
            window.open(`/progetti/progetto/${a.id}`);
            end()
        }
      },
    ]
  }
  return OBJ;
}


export var lead_timeEnv = () => {
  var env: any = {
    Modules: {
      "lead_time": true
    },
    Cruds: [lead_time()],
    Menu: [...lead_time().MenuItems]
  }
  return env;

}
